import React from 'react'
import PropTypes from 'prop-types'
import { Tag, Tooltip } from 'antd'
import classNames from 'classnames'
// Style Sheet
import './TagGroup.css'

export default class TagGroup extends React.Component {
  static propTypes = {
    tags: PropTypes.array.isRequired,
    // moreTags: PropTypes.array,
    moreTags: PropTypes.bool,
    isExlude: PropTypes.bool,
    activeTagsType: PropTypes.string,
    onDelete: PropTypes.func,
    HideCloseIcon: PropTypes.bool,
    onClick: PropTypes.func,
    edit: PropTypes.bool,
    editIndex: PropTypes.number,
    postCodeTag: PropTypes.bool
  }

  state = {
    tags: [],
    name: '',
    editInputIndex: -1,
    editInputValue: '',
    onClick: () => {}
  }

  handleClose = (removedTag) => {
    const { onDelete, activeTagsType, moreTags } = this.props
    let filteredTags = this.props.tags
    if (moreTags && moreTags.length > 0) {
      filteredTags = [...filteredTags, ...moreTags]
    }
    const tags = filteredTags.filter((tag) => tag !== removedTag)
    onDelete(tags, activeTagsType)
  }

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus())
  }

  handleInputChange = (e) => {
    this.setState({ name: e.target.value })
  }

  handleInputConfirm = () => {
    const { name } = this.state
    let { tags } = this.state
    if (name && tags.indexOf(name) === -1) {
      tags = [...tags, name]
    }
    this.setState({
      tags,
      name: ''
    })
  }

  handleEditInputChange = (e) => {
    this.setState({ editInputValue: e.target.value })
  }

  handleEditInputConfirm = () => {
    this.setState(({ tags, editInputIndex, editInputValue }) => {
      const newTags = [...tags]
      newTags[editInputIndex] = editInputValue

      return {
        tags: newTags,
        editInputIndex: -1,
        editInputValue: ''
      }
    })
  }

  saveInputRef = (input) => {
    this.input = input
  }

  saveEditInputRef = (input) => {
    this.editInput = input
  }

  handleTagSplit = (tag) => {
    if (!this.props.postCodeTag) return tag
    const [...parts] = tag.trim().split(' ')
    const distance = parts.pop()
    const location = parts.join(' ')
    return { location, distance }
  }

  render() {
    const { isExlude, HideCloseIcon, onClick, postCodeTag, edit, editIndex } = this.props
    return (
      <>
        {this.props.tags?.length > 0 &&
          this.props.tags.map((tag, index) => {
            // if (editInputIndex === index) {
            //   return (
            //     <Input
            //       ref={this.saveEditInputRef}
            //       key={tag}
            //       size="small"
            //       className="tag-input"
            //       value={editInputValue}
            //       onChange={this.handleEditInputChange}
            //       onBlur={this.handleEditInputConfirm}
            //       onPressEnter={this.handleEditInputConfirm}
            //     />
            //   )
            // }

            const isLongTag = tag?.length > 20

            const tagVal = isLongTag
              ? `${decodeURIComponent(tag?.toString().replace('%', '')).slice(0, 20)}...`
              : decodeURIComponent(tag?.toString().replace('%', ''))
            const ele = this.handleTagSplit(tagVal)

            const tagElem = (
              <Tag
                className={classNames(
                  isExlude && 'excluded',
                  'edit-tag',
                  edit && editIndex === index && 'edit-mode'
                )}
                key={tag}
                closable={!HideCloseIcon && index !== -1}
                onClose={() => {
                  !HideCloseIcon && this.handleClose(tag, index)
                }}
                style={{ marginBottom: 10 }}
                // onClick={() => onClick(tag, index)}
                onClick={() => typeof onClick === 'function' && onClick(tag, index)}
              >
                {postCodeTag ? (
                  <span>
                    {ele?.location}{' '}
                    <span
                      className={`${
                        edit && editIndex === index
                          ? 'edit-mode-distance'
                          : 'non-edit-mode-distance'
                      }`}
                    >
                      {ele?.distance}
                    </span>
                  </span>
                ) : (
                  <span>{tagVal}</span>
                )}
              </Tag>
            )
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            )
          })}
      </>
    )
  }
}
